/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { icons } from "../../../../environments/config";
@Component({
  selector: "app-gateway-selection",
  templateUrl: "./gateway-selection.component.html",
  styleUrls: ["./gateway-selection.component.scss"],
})
export class GatewaySelectionComponent implements OnInit {
  razorpay = icons.paymentGateway.razorpay;
  stripe = icons.paymentGateway.stripe;
  constructor(
    private matDialogRef: MatDialogRef<GatewaySelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}
  value = "";
  ngOnInit(): void {
    console.log(this.dialogData);
  }
  selectGateway(type) {
    this.value = type;
  }
  emitSelection() {
    this.matDialogRef.close(this.value);
  }
  closeDialog() {
    this.matDialogRef.close();
  }
}
